import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';

interface IPageDO0007 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrenceTCHOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
}
/* @ngInject */
export default function Do0007Controller(Menu: IMenuClass,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemEcran: IMenuItemEcranClass,
    do0022Route: IRoute) {
    const vm: IPageDO0007 = this;

    vm.multiOccurrenceTCHOptions = {
        bloc: 'tch',
        colonnesVisibles: [
            { nom: 'gracod', largeur: 130 },
            { nom: 'gradsc', largeur: 202 },
            { nom: 'tchseqaff', largeur: 105 },
            { nom: 'tchdsc', largeur: 560 },
        ],
        colonnesCachees: ['poscleint', 'temcleint', 'gracleint'],
        formulaire: new Formulaire([
            new FormulaireItem('gracleint'),
            new FormulaireItem('tchseqaff'),
            new FormulaireItem('tchdsc', { required: true }),
        ])
    };

    vm.multiOccurrenceOptions = {
        colonnesCachees: ['poscleint', 'temcleint'],
        colonnesVisibles: [
            { nom: 'posnumdoc', largeur: 89 },
            { nom: 'postitabr', largeur: 262 },
            { nom: 'urgcod', largeur: 125 },
            { nom: 'urgdscabr', largeur: 231 },
            { nom: 'temcod', largeur: 89 },
            { nom: 'temdscabr', largeur: 218 },
            {
                nom: 'posdscfon', largeur: 218, menu: [
                    new MenuItemEcran(
                        'LBL_RESERVE',
                        do0022Route.NAME,
                        (rowData: any) => ({
                            id: rowData.poscleint
                        }),
                        {
                            icon: 'launch',
                            iconButton: true,
                            onClose: () => vm.multiOccurrence.fetchDataList()
                        }
                    )
                ]
            }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('poscleint'),
            new FormulaireItem('urgcleint'),
            new FormulaireItem('temcleint')
        ]),
        multiOccurrenceOptionsEnfant: vm.multiOccurrenceTCHOptions
    };
}
